import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';
import { darken } from 'polished';

export const DRIVER_TAB_WIDTH = 275;

export const tabContainer = css`
    width: ${DRIVER_TAB_WIDTH}px;
    flex-direction: column;
    transition: max-width 300ms ease-out;
    transform: translate3d(0, 0, 0);
    background-color: white;
    position: absolute;
    max-height: 80vh;
    top: 20px;
    left: 20px;
    border-radius: 8px;
    overflow: hidden;

    @media (max-width: 1000px) {
        position: relative;
        top: auto;
        left: auto;
        width: 100%;
    }
`;

export const listContainer = css`
    outline: none;
    margin: 0;
    align-self: stretch;
    flex: 1;
    overflow-y: auto;
    background-color: white;
    padding: 0;
`;

export const makeMeADriverButton = css`
    display: block;
    border: 1px solid ${theme.primary};
    border-radius: 1000px;
    color: ${theme.primary};
    padding: 4px 12px;
    margin: 4px;
    user-select: none;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background-color: ${darken(0.1, theme.primary)};
        color: white;
    }
`;

export default {
    filtersContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0 4px',
        marginTop: 10,
        marginBottom: 10
    },
    panelContainer: {
        flex: '1 0 auto',
        maxHeight: '75vh',
        outline: 'none'
    },
    noDriversText: {
        backgroundColor: 'white',
        padding: 20
    },
    emptyContainer: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white'
    },
    emptyTitle: {
        fontWeight: 'bold',
        textAlign: 'center'
    }
};
